import { OptionSelected, SelectProps } from './Select';
const { Autocomplete } = window.labMaterial;
const { CircularProgress, TextField } = window.Material;

interface AsyncProps extends SelectProps {
  autoFocus: boolean;
  loadOptions: (input?: string) => Promise<any>;
  updateParam?:any;

}

interface AsyncState {
  options: OptionSelected[];
  loading: boolean;
  inputValue: string;
  updateParam?:any;
}

export default class Async extends React.PureComponent<AsyncProps, AsyncState> {
  constructor(props: AsyncProps) {
    super(props);

    this.state = {
      options: [],
      inputValue: '',
      loading: false,
      updateParam:'',
    };
  }

  componentDidMount() {
    this.getOptions('');
  }

  componentDidUpdate(_lastProps: AsyncProps, _lastState: AsyncState) {
    if (this.props?.updateParam !== _lastProps?.updateParam) {
      this.getOptions('');
    }
    const inputVal = this.props?.multi ? "" : (typeof this.state?.inputValue === 'string' && this.state.inputValue.length > 0 ? this.state.inputValue : this.props.value?.label ?? "");

    if (!this.props?.multi && _lastState?.inputValue !== inputVal) {
      this.setState((state) => { return { ...state, inputValue: inputVal } });
    }
  }

  onInputChange = (event: any) => {
    const { value } = event.target as HTMLInputElement;
    if (event.nativeEvent?.type === 'input') {
      this.setState((state) => { return { ...state, inputValue: value ?? "" } });
      if (value?.length > window.Edocat.Config.AuthorityMinLength) {
        this.getOptions(value);
      }
    }
  };

  handleChange = (event: React.ChangeEvent, value: any, reason: string, option: any) => {
    let { onChange, multi } = this.props;
    if (typeof onChange === 'function') {
      onChange(value);
    }

    //reset Input value on change
    this.setState((state) => {
      return { ...state, loading: false, inputValue: multi ? "" : value?.label }
    });
    this.getOptions();
  };

  getOptions = async (input = '') => {
    const { loadOptions } = this.props;

    this.setState({
      loading: true,
    });

    const options = await loadOptions(input);

    this.setState((state) => ({ ...state, options, loading: false }));
  };

  filterOptions = (item: OptionSelected) => {
    const { filterOptions } = this.props;

    return filterOptions ? filterOptions(item) : true;
  };

  render() {
    const {
      label,
      disabled,
      onChange,
      value,
      multi,
      placeholder,
      className,
      mandatory,
      getOptionLabel,
      error,
      filterOptions,
      creatable,
      id,
      renderTags,
      getOptionDisabled,
      renderOption,
      important,
      helperText,
      filterSelectedOptions,
      getOptionSelected
    } = this.props;

    const finalValue = multi ? (value ?? []) : value;

    return (
      <Autocomplete
        id={id}
        disabled={disabled}
        className={className}
        filterOptions={filterOptions}
        filterSelectedOptions={filterSelectedOptions ?? true}
        loading={this.state.loading}
        multiple={multi}
        onChange={this.handleChange}
        options={this.state.options}
        getOptionSelected={getOptionSelected ?? ((option: OptionSelected, value: OptionSelected): boolean => option?.value === value?.value)}
        getOptionDisabled={getOptionDisabled}
        getOptionLabel={getOptionLabel ?? ((option: any): string => option?.label || '')}
        disableClearable={mandatory}
        renderTags={renderTags}
        ChipProps={{size: 'small',}}
        // inputValue={this.state.inputValue}
        // onInputChange={this.onInputChange} https://github.com/mui/material-ui/blob/v4.x/packages/material-ui-lab/src/useAutocomplete/useAutocomplete.js#L152
        renderInput={(params: any) => (
          <TextField
            {...params}
            label={label}
            placeholder={
              placeholder ||
              ((multi && finalValue?.length === 0) || (!multi && !finalValue)
                ? `${window.Alfresco.messages.global['button.select']}...`
                : '')
            }
            variant={'outlined'}
            required={mandatory}
            error={!!error}
            helperText={error || important || helperText}
            onChange={this.onInputChange}
            inputProps={{ ...params.inputProps, value: (!this.props?.multi ? (typeof this.state?.inputValue === 'string' && this.state.inputValue.length > 0 ? this.state.inputValue : this.props.value?.label ?? "") : (this.state?.inputValue ?? "")) }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {this.state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            InputLabelProps={{ shrink: true }}
          />
        )}
        value={finalValue}
        freeSolo={creatable}
        renderOption={renderOption}
      />
    );
  }
}
